import { useCurrentOrganization } from './useOrganization';

/**
 * The caller's role in the current organization, served with the
 * organization itself (`myRole` on `getCurrentOrganization`) — no dedicated
 * request. `null` only while the organization is still loading.
 */
export function useUserOrganizationRole() {
  const { data: organization } = useCurrentOrganization();
  return organization?.myRole ?? null;
}
